//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EarlySettleChargeRule from "@/components/Repay/EarlySettleChargeRule";
import { getBizType } from "@/js/utils";

export default {
    name: "prepayDiscountList",
    components: {
        EarlySettleChargeRule
    },
    data() {
        return {
            isDetailShow: false,
        };
    },
    props: {
        repayInitData: {
            type: Object,
        },
        isChooseGold: String,
        repayPage: Number,
    },
    computed: {
        isGoldOpened() {
            return this.isChooseGold === "y";
        },
        hasClearPlanType() {
            const { clearPlanType } = this.repayInitData;
            return (
                clearPlanType == "DailyFee" ||
                clearPlanType == "TermFee" ||
                clearPlanType == "PenaltyFee"
            );
        },
        isLoan() {
            return getBizType() == "Loan";
        },
        discountInfo() {
            const {
                interestFreeAmount,
                activityType,
                cashBackAmount,
                preClearplanType,
                repayShowPrincipal,
                repayShowInterestFee,
                sevenFreeCoupon,
                isFeeTouMing,
                sevenFreeCouponLimitDay
            } = this.repayInitData;
            return {
                prepay: {
                    text:
                        activityType === 410
                            ? "提前还清免息券"
                            : preClearplanType == 4
                                ? "提前结清减免"
                                : "提前还清减免费用",
                    amount: interestFreeAmount,
                    cashAmount: cashBackAmount,
                },
                principal: {
                    text: "还款本金",
                    amount: repayShowPrincipal,
                    isShow: repayShowPrincipal > 0 && this.isLoan,
                },
                interestFee: {
                    text: "待还息费（包含罚息）",
                    amount: repayShowInterestFee,
                    isShow: repayShowInterestFee > 0 && this.isLoan,
                },
                // hasDiscount: (activityType === 410 && interestFreeAmount > 0) || (activityType === 420 && sevenFreeCoupon > 0),
                hasDiscount: interestFreeAmount > 0,
                hasCashAmount: cashBackAmount > 0,
                preDiscountCap36:
                    (this.isLoan
                        ? this.hasClearPlanType
                        : preClearplanType == 4) ||
                    [8, 5].includes(preClearplanType),
                isFeeTouMing: isFeeTouMing,
                sevenFreeCoupon: {
                    text: sevenFreeCouponLimitDay ? `0息费借${sevenFreeCouponLimitDay}天` : "提前还清免息费",
                    amount: sevenFreeCoupon,
                    isShow: sevenFreeCoupon > 0
                }
            };
        },

        parter1() {
            return this.discountInfo.hasDiscount ||
                this.discountInfo.principal.isShow ||
                this.discountInfo.interestFee.isShow;
        },

        parter2() {
            return this.discountInfo.hasCashAmount || this.isGoldOpened || this.discountInfo.sevenFreeCoupon.isShow;
        },

        hasChooseGold() {
            return [3, 4].includes(this.repayPage) && this.isChooseGold === "y";
        },
    },
    methods: {
        showDialog() {
            this.isDetailShow = true;
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_prepay_discount",
                tgt_name: "h5-paycash-提前结清减免按钮",
                page: "还款确认页",
                param4: this.repayInitData.preClearplanType,
            });
        },
    },
};
